var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      ref: "dialog",
      attrs: { "return-value": _vm.manualInputTime, width: "350px" },
      on: {
        "update:returnValue": function ($event) {
          _vm.manualInputTime = $event
        },
        "update:return-value": function ($event) {
          _vm.manualInputTime = $event
        },
        "click:outside": _vm.closeDialog,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-text-field",
                _vm._g(
                  {
                    staticClass: "centered-input mx-2",
                    attrs: {
                      label: _vm.label,
                      disabled: _vm.disabled,
                      rules: _vm.rules,
                      readonly: "",
                    },
                    model: {
                      value: _vm.manualInputTime,
                      callback: function ($$v) {
                        _vm.manualInputTime = $$v
                      },
                      expression: "manualInputTime",
                    },
                  },
                  on
                ),
                [
                  _c(
                    "template",
                    { slot: "prepend-inner" },
                    [
                      _c(
                        "v-icon",
                        {
                          style: { cursor: "pointer" },
                          attrs: {
                            large: "",
                            color: !_vm.disabled ? _vm.color : "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setAddMinit2Time(-1)
                            },
                          },
                        },
                        [_vm._v("mdi-arrow-left")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "template",
                    { slot: "append" },
                    [
                      _c(
                        "v-icon",
                        {
                          style: { cursor: "pointer" },
                          attrs: {
                            large: "",
                            color: !_vm.disabled ? _vm.color : "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setAddMinit2Time(1)
                            },
                          },
                        },
                        [_vm._v("mdi-arrow-right")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.modal2,
        callback: function ($$v) {
          _vm.modal2 = $$v
        },
        expression: "modal2",
      },
    },
    [
      _c(
        "v-time-picker",
        {
          attrs: {
            format: "24hr",
            max: _vm.max,
            min: _vm.min,
            disabled: _vm.disabled,
          },
          on: {
            input: function ($event) {
              _vm.manualInputTime = _vm.currentTime
            },
            "click:hour": _vm.hourSelected,
          },
          model: {
            value: _vm.currentTime,
            callback: function ($$v) {
              _vm.currentTime = $$v
            },
            expression: "currentTime",
          },
        },
        [
          _c(
            "v-col",
            { staticClass: "px-2 py-0 ma-0", attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      !_vm.showManualInputField
                        ? _c("v-text-field", {
                            ref: "text",
                            staticClass: "centered-input",
                            attrs: {
                              label: "Zeit eingeben",
                              autocomplete: "off",
                              autofocus: true,
                            },
                            nativeOn: {
                              keypress: function ($event) {
                                return _vm.isNumber()
                              },
                              keyup: [
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.closeDialog()
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "left",
                                      37,
                                      $event.key,
                                      ["Left", "ArrowLeft"]
                                    )
                                  )
                                    return null
                                  if ("button" in $event && $event.button !== 0)
                                    return null
                                  return _vm.setAddMinit2Time(-1)
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "right",
                                      39,
                                      $event.key,
                                      ["Right", "ArrowRight"]
                                    )
                                  )
                                    return null
                                  if ("button" in $event && $event.button !== 2)
                                    return null
                                  return _vm.setAddMinit2Time(1)
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "up",
                                      38,
                                      $event.key,
                                      ["Up", "ArrowUp"]
                                    )
                                  )
                                    return null
                                  return _vm.setAddMinit2Time(60)
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "down",
                                      40,
                                      $event.key,
                                      ["Down", "ArrowDown"]
                                    )
                                  )
                                    return null
                                  return _vm.setAddMinit2Time(-60)
                                },
                              ],
                            },
                            model: {
                              value: _vm.manualInputTime,
                              callback: function ($$v) {
                                _vm.manualInputTime = $$v
                              },
                              expression: "manualInputTime",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { justify: "center", "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "text-center px-2 py-0 mb-2" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              _vm.modal2 = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "text-center px-2 py-0 mb-2" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.closeDialog()
                            },
                          },
                        },
                        [_vm._v("OK")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }